import { render } from "./pencil.vue?vue&type=template&id=eb2fd5bc"
import script from "./pencil.vue?vue&type=script&lang=js"
export * from "./pencil.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__